import { render, staticRenderFns } from "./ContractCompany.vue?vue&type=template&id=8ec45f98&scoped=true"
import script from "./ContractCompany.vue?vue&type=script&lang=js"
export * from "./ContractCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec45f98",
  null
  
)

export default component.exports